<template>
    <div class="c_table_wrap table_theme_wrap">
        <table class="theme_table mr20">
            <colgroup>
                <col width="100px;">
            </colgroup>
            <tr>
                <td class="theme_head" style="width: 100px;"></td>
                <td class="theme_head">
                    <el-button type="primary" @click="checkValidator()">추가</el-button>
                </td>
            </tr>
            <tr v-for="item in themeCountries" :key="`write-${item.parser}`">
                <td class="c_t_title">{{ item.name }}</td>
                <td>
                    <div>
                        <el-input :value="returnData(item.parser)" @input="setData(item.parser,$event)"
                                  maxlength="10"></el-input>
                    </div>
                </td>
            </tr>
        </table>
        <table class="theme_table mr10" v-for="theme in themeData" :key="theme.st_idx ">
            <tr>
                <td class="theme_head" >
                    <el-button type="danger" @click="deleteConfirm(theme.st_idx)">삭제</el-button>
                </td>
            </tr>
            <tr v-for="item in themeCountries" :key="`write-${item.parser}`">
                <td>
                    <div>
                        <el-input class="theme_data_input" v-model="theme[item.parser]"
                        maxlength="10"></el-input>
                        <el-button type="primary" size="small" @click="updateTheme(theme.st_idx,item.parser,theme[item.parser])">저장</el-button>
                    </div>
                </td>
            </tr>

        </table>

        <div class="table_search row has_bc">
            <el-row>
                <el-col :span="12">
                </el-col>
                <el-col :span="12" class="text_right">
                </el-col>
            </el-row>
        </div>

    </div>
</template>

<script>
import {themeCountries} from "@/service/themeService";
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";

export default {
    name: "ThemeComponent",
    mixins: [alertMixins],
    components: {},
    props: {},
    data() {
        return {
            themeData: [],
            themeCountries: themeCountries,
            st_theme_en: '',
            st_theme_es: '',
            st_theme_fr: '',
            st_theme_de: '',
            st_theme_it: '',
            st_theme_nl: '',
            st_theme_pl: '',
            st_theme_pt: '',
            st_theme_sv: '',
            st_theme_ru: '',
            st_theme_ko: '',
            st_theme_zhs: '',
            st_theme_zht: '',
            st_theme_ja: '',
            st_theme_ar: '',
            st_theme_id: '',
            st_theme_vi: '',
            st_theme_th: '',
            st_theme_hi: '',
            st_theme_bn: '',
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.getTheme()
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        getTheme() {
            let params =
                {
                    ip: 0,
                }
            try {
                this.$api.$theme.getTheme(params).then(res => res.Data.Result).then(res => {
                    this.themeData = res.List
                })
            } catch (e) {

            }
        },
        deleteConfirm(idx) {
        this.createConfirm({
            content : '테마를 삭제하시겠습니까? 해당 테마를 등록한 게시글에 추가테마가 없을 경우 null로 표기됩니다.',
            confirm:()=>{
                this.deleteTheme(idx)
            },
            cancel:()=>{

            }
        })
        },
        deleteTheme(idx) {
            let params = {
                st_idx: idx
            }
            try {
                this.$api.$theme.deleteTheme(params).then(res => res.Data.Result).then(res => {
                    if (res.Info.type === 1) {
                        this.getTheme()
                        this.createAlert({content : '삭제되었습니다.'})
                    } else {
                        this.errorAlert('테마삭제에 실패했습니다.')
                    }
                })
            } catch (e) {
                console.log(e)
            }
        },
        addTheme() {
            let params = {}
            util.each(this.themeCountries, (data, index, arr) => {
                params[data.parser] = this[data.parser]
            })
            try {
                this.$api.$theme.createTheme(params).then(res => res.Data.Result).then(res => {
                    if (res.Info.type === 1) {
                        this.getTheme()
                        this.initTheme()
                    } else {
                        this.errorAlert('테마추가에 실패했습니다.')
                    }
                })
            } catch (e) {
                console.log(e)
            }
        },
        initTheme() {
            this.themeCountries.forEach(v => {
                this[v.parser] = ''
            })
        },
        returnData(key) {
            return this[key]
        },
        checkValidator() {

            let check = false
            let ovl = false
            this.themeCountries.forEach(v => {
                if (util.isEmpty(this[v.parser])) {
                    check = true
                }
                else if(this.themeData.filter( theme => theme[v.parser] === this[v.parser])){
                    ovl = true
                }
            })
            if (check) {
                this.errorAlert('모두 입력해주세요.')
            }else if(ovl){
                this.errorAlert('중복된 테마가 존재합니다.')
            } else {
                this.addTheme()
            }
        },
        updateTheme(idx,type,value){
            if(util.isEmpty(value)){
                this.errorAlert('테마를 입력해 주세요.')
                return false
            }
            if(!util.isEmpty(this.themeData.filter( theme => theme.st_idx !== idx && theme[type] === value))){
                this.errorAlert('중복된 테마가 존재합니다.')
                return false
            }
            let params = {
                st_idx : idx,
            }
            params[type] = value
            try {
                this.$api.$theme.updateTheme(params).then(res => res.Data.Result).then(res => {
                    if (res.Info.type === 1) {
                        this.getTheme()
                        this.errorAlert('저장되었습니다.')
                    } else {
                        this.errorAlert('저장에 실패했습니다.')
                    }
                })
            } catch (e) {
                console.log(e)
            }
        },
        setData(key, value) {
            this[key] = value
        },
    },
    watch: {},
}
</script>

<style lang="scss">
.theme_table {
    vertical-align: top;
    display: inline-block;

    .theme_data_input {
        width: calc(100% - 65px);
        margin-right: 10px;
    }

    width: unset !important;
}

.theme_head {
    width: 300px;
    text-align: center;
    border: none !important;
    background-color: transparent !important;
}
</style>